"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "makeComplexPermissionComponent", {
  enumerable: true,
  get: function get() {
    return _makeComplexPermissionComponent.default;
  }
});
Object.defineProperty(exports, "makeCompoundPermissionComponent", {
  enumerable: true,
  get: function get() {
    return _makeCompoundPermissionComponent.default;
  }
});
Object.defineProperty(exports, "makeSimplePermissionComponent", {
  enumerable: true,
  get: function get() {
    return _makeSimplePermissionComponent.default;
  }
});
exports.Scopes = exports.Scope = exports.Gates = exports.Gate = void 0;

var _makeComplexPermissionComponent = _interopRequireDefault(require("./factories/makeComplexPermissionComponent"));

var _makeCompoundPermissionComponent = _interopRequireDefault(require("./factories/makeCompoundPermissionComponent"));

var _makeSimplePermissionComponent = _interopRequireDefault(require("./factories/makeSimplePermissionComponent"));

var _defaultSelectors = require("./selectors/defaultSelectors");

var Gate = (0, _makeSimplePermissionComponent.default)(_defaultSelectors.hasGate);
exports.Gate = Gate;
var Scope = (0, _makeSimplePermissionComponent.default)(_defaultSelectors.hasScope);
exports.Scope = Scope;
var Gates = (0, _makeCompoundPermissionComponent.default)(_defaultSelectors.hasGate);
exports.Gates = Gates;
var Scopes = (0, _makeCompoundPermissionComponent.default)(_defaultSelectors.hasScope);
exports.Scopes = Scopes;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/permission-components/static-1.43/js/index.js
// module id = 660
// module chunks = 209 210 211 212